import log from 'loglevel';
import getProductListByPLC from "../Action/GetProductList/getProductListByPLC";

const handleProductInputChange = async (option,
  currentHULADetails,
  productInfoPage,
  dispatch,
  credentials,
  ) => {
  
  log.debug('./handler/handleProductInputChange function called and chose option from dropdown: ', option)

  /* 
    NOTE: if user chose value of product version and then change mind to choose product different,
    then cleanup the previoues value stored into React state.
  */
  if(productInfoPage.showVersionDropdown) {
    // Note: Cleanup older data into the state.
    log.debug('dispatch CLEANUP_REQUESTING_PRODUCT event into order to update React state!')
    dispatch({ type: 'CLEANUP_REQUESTING_PRODUCT'});
  } 

  let plc = '';
  let hulsNotEligible = false;
  const productList = currentHULADetails.productKeyMapping;
  productList.forEach(product => {
    let { productLineName } = product;
    productLineName = productLineName.replace('Autodesk ', '');
    if(productLineName === option && Number.isNaN(Number(product.release))){
      //  serial number you entered is for an older version that is no longer supported.
      hulsNotEligible = true;
    }
    if(productLineName === option && Number(product.release) !== 'NaN') {
      plc = product.productLineCode
    }
  });

  if(hulsNotEligible) {
    log.debug('./handler/handleProductInputChange HULA not eligible! ');
    dispatch({ type: 'HULA_NO_LOGER_SUPPORTED'});
  } else {
    
    try {
      const prodListPreviouesVersionEligible = await getProductListByPLC(plc, credentials);
      log.log('./Action/GetPreviousVersionProducts CrossGrade response :- ', JSON.stringify(prodListPreviouesVersionEligible, 0, 2));

      // get the current version of product.
      // e.g. Advance Steel: (2) ["Advance Steel 2018", "Advance Steel 2019"] -> 2019 is current version.
      const currentProductVersion = currentHULADetails.storeProductVersion[`${option}`];
      const currentVersion = currentProductVersion[currentProductVersion.length - 1].slice(-4);
      
      let crossGrade;
      let suggestedCrosGradeProduct;
      let productVertsions = [currentHULADetails.storeProductVersion[`${option}`].pop()];
      const crossGradeProduct = [];
      // if previoues product list of versions are not an empty
      if(prodListPreviouesVersionEligible.data[0] !== null && prodListPreviouesVersionEligible.data.product[0] !== null){
        const { product:crossGradeProd } = prodListPreviouesVersionEligible.data; 
        crossGrade = crossGradeProd.filter((prd, i, element) => {
          const nextElement = element[i+1];
          if(prd.version === nextElement?.version 
            && prd.priorVersion === nextElement?.priorVersion 
            && prd.productName !== nextElement?.productName){
              return false;
          } 
          return true;
        })
        log.debug('Clean response of PV hula products(Array) : ', crossGrade);
        crossGrade.forEach(product => {
          if(Number(currentVersion) - Number(product.priorVersion) < 4 
            && Number(product.priorVersion < Number(currentVersion))){
            let { productName } = product;
            productName = productName.replace('Autodesk ', '');   
            crossGradeProduct.push(`${productName} ${product.priorVersion}`)
          }
        });

        suggestedCrosGradeProduct = crossGradeProduct.filter(prod => !productVertsions.includes(prod))
        // join two arrays.
        productVertsions = [...productVertsions, ...crossGradeProduct];
      }
      
      productVertsions = productVertsions.sort();
      productVertsions = productVertsions.sort((a, b) => {
        if(Number(a.slice(-4)) > Number(b.slice(-4))){
          return -1;
        }
        return 1;
      })
      productVertsions = [...new Set(productVertsions)];
      productVertsions = productVertsions.filter(a => Number(a.slice(-4)) >= 2017);
      
      log.debug(" Dispatch ENTER_REQUESTING_PRODUCT with payload : ", JSON.stringify(
        {
          selectedProduct: option,
          showVersionDropdown: true,
          productVersions: productVertsions,
          crossGradeProducts: crossGrade,
          suggestedCrosGradeProduct,
        },
        0,
        2));
      dispatch({
        type: 'ENTER_REQUESTING_PRODUCT',
        payload: {
          selectedProduct: option,
          showVersionDropdown: true,
          productVersions: productVertsions,
          crossGradeProducts: crossGrade,
          suggestedCrosGradeProduct,
        },
      });
    } catch (e) {
      log.error('./handle/handleProductInputChange error : ', e);
      dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
    }
  }
}
export default handleProductInputChange;